import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PriceBlock from '../../base_price-block/component';
import Link from '../../base_link/component';
import ErrorMessage from '../../ui_error-message/component';
import OrderlineReference from '@components/ui_orderline-reference/component';
import LoyaltyPrice from '@components/ui_loyalty-price/component';
import { t } from '@utils/i18n';
import HistoryToggle from '@components/ui_history_toggle/component';
import {
  Button,
  Icon,
  TitleAndSubtitle,
  ProductImage,
  QuantityInput,
} from 'audamatic-ui';
import { numFormatToCurrency } from '@utils';
import { Product } from '@utils/product';
import Text from '@text';
import Typeset from '@components/base_typeset/component';
import './styles/styles.scss';

const AnkeilerBasket = (props) => {
  const {
    store,
    productHistory,
    item,
    lastItem,
    updateOrderItemReference,
    deleteOrderItem,
    addFreeGift,
    updateOrderItemQuantity,
    googleTagMethods,
  } = props;
  const product = new Product(item || {});

  const {
    id,
    totals,
    url,
    name,
    personsLinks,
    tbaproducttype,
    language,
    badges,
    expressOrder,
    productAvailability,
    singleBasePrice,
    isEbook,
    maxOrder,
    quantity = 1,
    dePointsPrice,
    orderLineReference = '',
  } = product;

  const [newQuantity, setNewQuantity] = useState(quantity);
  const [
    showConfirmationButtonOrderlineReference,
    setShowConfirmationButtonOrderlineReference,
  ] = useState(false);
  const [reference, setReference] = useState(orderLineReference);
  const [errorMessage, setErrormessage] = useState('');

  const productPrice = totals && totals.total ? totals.total.value : 0;

  const arrayOfAttributes = [tbaproducttype];
  if (typeof language === 'object') {
    language.forEach((language) => arrayOfAttributes.push(language));
  } else {
    arrayOfAttributes.push(language);
  }
  const attributes = arrayOfAttributes.filter(Boolean);

  const originalTotal = totals && totals.originalTotal.value;
  const isHigher = originalTotal > productPrice;
  const originalPrice = isHigher ? numFormatToCurrency(originalTotal) : '';

  const priceToPay = numFormatToCurrency(productPrice);

  const priceswithLoyalty = [
    {
      label: t('pricing.text.depoints'),
      amount: dePointsPrice,
    },
    {
      label: t('pricing.text.standard'),
      amount: productPrice,
    },
  ];

  const showErrorMessageOrderLine = (hasError) => {
    if (hasError) {
      setErrormessage('orderline');
    } else {
      setErrormessage('');
    }
  };

  const confirmOrderline = (e) => {
    e.preventDefault();
    setShowConfirmationButtonOrderlineReference(false);
    updateOrderItemReference({
      itemId: id,
      value: reference,
    });
  };

  const updateQuantity = (newValue) => {
    const value = newValue > 0 && newValue <= maxOrder ? newValue : maxOrder;
    setNewQuantity(newValue);
    updateOrderItemQuantity({
      itemId: id,
      value,
    });
  };

  const pushGoogleTags = () => {
    googleTagMethods().pushProductGoogleTag(product);
  };

  const errorMesage = (
    <Text replacements={{ quantity: maxOrder }}>quantity.error.message</Text>
  );

  const title = (
    <Link to={url} onClick={pushGoogleTags}>
      <span dangerouslySetInnerHTML={{ __html: name }}></span>
    </Link>
  );

  if (product.unwantedItem) {
    return (
      <div
        className={`block decorated ankeiler-basket-wide ${
          lastItem ? 'last-item' : ''
        }`}
      >
        <div className="unwanted-free-item">
          <div>
            <Typeset tag="span" bold>
              "{product.name}"
            </Typeset>
            <Typeset tag="span">
              {' '}
              - <Text>basket.product.freegift.removed</Text>
            </Typeset>
          </div>
          <Button variant="link" onClick={() => addFreeGift(product)}>
            <Text>basket.product.freegift.addBackToBasket</Text>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`block decorated ankeiler-basket-wide ${
        lastItem ? 'last-item' : ''
      }`}
    >
      <div className="shoppingbasket-product">
        <div className="grid-item">
          <div className="product">
            <div className="hidden-xs button-group">
              <Button
                variant="secondary"
                size="medium"
                iconLeft={<Icon name="Trash" size="sm" />}
                onClick={() => deleteOrderItem(product)}
                data-test-id="button-deleteItem"
              />
              <HistoryToggle
                product={product}
                productHistory={productHistory}
              />
            </div>
            <div className="img-container">
              <div className="image wrapper small">
                <Link to={url} title={name} onClick={pushGoogleTags}>
                  <div className="product-image-wrapper">
                    <ProductImage product={product} maxHeight={84} />
                  </div>
                </Link>
              </div>
            </div>
            <div className="product-information">
              <div className="title-wrapper haslink">
                <TitleAndSubtitle
                  title={title}
                  subtitle={personsLinks}
                  data-test-id="titleAndSubtitle"
                />
              </div>
              {!!badges.length &&
                (!!badges[0].link ? (
                  <Link to={badges[0].link} className="promo-notification">
                    {badges[0].title}
                  </Link>
                ) : (
                  <p className="promo-notification">{badges[0].title}</p>
                ))}
              {expressOrder ? (
                <div className="express-order">
                  <Icon name="DeliveryTruck" size="sm" />
                  <Text>expressorder.basketitem-notification</Text>
                </div>
              ) : (
                <p className="delivery-promise">{productAvailability}</p>
              )}

              <p className="meta visible-xs">{attributes.join('\r\n')}</p>
            </div>
          </div>
        </div>
        <div className="grid-item wrap-right">
          <div className="grid-item center-v center-h reverse">
            <div className="grid-item column">
              <OrderlineReference
                showConfirmationButtonOrderline={() =>
                  setShowConfirmationButtonOrderlineReference(true)
                }
                value={reference}
                changeReference={(value) => setReference(value)}
                showErrorMessage={showErrorMessageOrderLine}
              />
              {showConfirmationButtonOrderlineReference && (
                <div
                  className="button-confirm"
                  onClick={confirmOrderline}
                  data-test-id="confirmOrderline"
                >
                  <Text>quantity.confirm.link</Text>
                </div>
              )}
              {errorMessage === 'orderline' && (
                <ErrorMessage>
                  <Text>orderline-reference.errormessage</Text>
                </ErrorMessage>
              )}
            </div>
          </div>
          <div className="grid-item column center-v">
            <div className="grid-item purchase-details">
              <div className="attributes hidden-xs center-v">
                <p>{attributes.join('\r\n')}</p>
              </div>
              <div className="mobile-buttongroup">
                <div className="mobile-inner">
                  <Button
                    variant="secondary"
                    size="medium"
                    iconLeft={<Icon name="Trash" size="sm" />}
                    onClick={() => deleteOrderItem(product)}
                    data-test-id="button-deleteItem"
                  />
                  <HistoryToggle
                    product={product}
                    productHistory={productHistory}
                  />
                </div>
              </div>
              <div>
                {!!singleBasePrice && !isEbook && (
                  <QuantityInput
                  changeQuantity={(newValue) => updateQuantity(newValue)}
                  errorMessage={errorMesage}
                  maxQuantity={maxOrder}
                  value={newQuantity}
                  />
                )}
              </div>
              <div className="center-v">
                <div className="product-prices">
                  {dePointsPrice ? (
                    <LoyaltyPrice prices={priceswithLoyalty} size="small" />
                  ) : (
                    <PriceBlock
                      store={store}
                      variant="basket"
                      priceToPay={priceToPay}
                      originalPrice={originalPrice}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AnkeilerBasket.propTypes = {
  /**
   * the orderline item
   */
  item: PropTypes.object,
  /**
   * function called when item should be deleted
   */
  deleteOrderItem: PropTypes.func,
  /**
   * the url to the action of the ankeiler
   */
  addFreeGift: PropTypes.func,
  url: PropTypes.string,
  /**
   * The callback function that updates the quantity
   * of the products on the basket
   */
  updateOrderItemReference: PropTypes.func,
  updateOrderItemQuantity: PropTypes.func,
  lastItem: PropTypes.bool,
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  store: PropTypes.object,
  productHistory: PropTypes.object,
  orderLineReference: PropTypes.string,
  googleTagMethods: PropTypes.func,
};
export default AnkeilerBasket;
